export default __webpack_public_path__ + "static/6-cd8414b599ad847ce7630edbb416e229.jpg";